export default {
  "areaChart": {
    "*": {
      "general": [{
        "responsive": true
      }],
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Courier New",
        "fontSize": 10,
        "legendMarkerRendering": "markerOnly",
        "matchLineColor": false
      }],
      "categoryAxis": [{
        "show": true,
        "axisType": "categorical",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": { "solid": { "color": "#01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      }],
      "valueAxis": [{
        "show": true,
        "position": "Right",
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": { "solid": { "color": "01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": { "solid": { "color": "#01B8AA" } },
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      }],
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#448822" } }
      }],
      "labels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "fontSize": 11,
        "fontFamily": "Courier New",
        "enableBackground": true,
        "backgroundColor": { "solid": { "color": "#0928DD" } },
        "backgroundTransparency": 30
      }],
      "lineStyles": [{
        "strokeWidth": 4,
        "strokeLineJoin": "bevel",
        "lineStyle": "dashed",
        "showMarker": true,
        "markerShape": "triangle",
        "markerSize": 10,
        "markerColor": { "solid": { "color": "#448822" } }
      }],
      "plotArea": [{
        "transparency": 20
      }]
    }
  },
  "actionButton": {
    "*": {
      "visualHeader": [{
        "show": true
      }]
    }
  },
  "card": {
    "*": {
      "labels": [{
        "color": { "solid": { "color": "#000000" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 10,
        "fontFamily": "Verdana"
      }],
      "categoryLabels": [{
        "show": true,
        "color": { "solid": { "color": "#01B8AA" } },
        "fontSize": 10,
        "fontFamily": "Verdana"
      }],
      "wordWrap": [{
        "show": true
      }],
      "background": [{
        "show": true,
        "color": {
          "solid": {
            "color": "#000000"
          }
        },
        "transparency": 0
      }
      ],
      "title": [{
        "show": true,
        "fontColor": { "solid": { "color": "#ffffff" } },
        "background": { "solid": { "color": "#062b60" } },
        "alignment": "left",
        "fontSize": 11,
        "fontFamily": "Segoe UI"
      }],
      "border": [{
        "show": true,
        "color": { "solid": { "color": "#062b60" } }
      }]
    }
  },
  "clusteredBarChart": {
    "*": {
      "general": [{
        "responsive": true
      }],
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Courier New",
        "fontSize": 10
      }],
      "categoryAxis": [{
        "show": true,
        "position": "Right",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "innerPadding": 22,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": { "solid": { "color": "#01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      }],
      "valueAxis": [{
        "show": true,
        "position": "Right",
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": { "solid": { "color": "01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": { "solid": { "color": "#01B8AA" } },
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      }],
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#448822" } }
      }],
      "labels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "labelPosition": "OutsideEnd",
        "fontSize": 11,
        "fontFamily": "Courier New",
        "enableBackground": true,
        "backgroundColor": { "solid": { "color": "#0928DD" } },
        "backgroundTransparency": 30
      }],
      "plotArea": [{
        "transparency": 20
      }]
    }
  },
  "clusteredColumnChart": {
    "*": {
      "general": [{
        "responsive": true
      }],
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Courier New",
        "fontSize": 10
      }],
      "categoryAxis": [{
        "show": true,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "innerPadding": 22,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": { "solid": { "color": "#01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      }],
      "valueAxis": [{
        "show": true,
        "position": "Right",
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": { "solid": { "color": "01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": { "solid": { "color": "#01B8AA" } },
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      }],
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#448822" } }
      }],
      "labels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "labelOrientation": "vertical",
        "labelPosition": "OutsideEnd",
        "fontSize": 11,
        "fontFamily": "Courier New",
        "enableBackground": true,
        "backgroundColor": { "solid": { "color": "#0928DD" } },
        "backgroundTransparency": 30
      }],
      "plotArea": [{
        "transparency": 20
      }]
    }
  },
  "decompositionTreeVisual": {
    "*": {
      "categoryLabels": [{
        "categoryLabelFontColor": { "solid": { "color": "#0100AA" } },
        "categoryLabelFontFamily": "Verdana",
        "categoryLabelFontSize": 13
      }],
      "analysis": [{
        "aiEnabled": true,
        "aiMode": "relative"
      }],
      "tree": [{
        "accentColor": { "solid": { "color": "#ABCDEF" } },
        "barsPerLevel": 20,
        "connectorDefaultColor": { "solid": { "color": "#0100AA" } },
        "connectorType": "round",
        "density": "sparse"
      }],
      "dataBars": [{
        "dataBarBackgroundColor": { "solid": { "color": "#AFB5B6" } },
        "dataBarScalingType": "parentNode",
        "dataBarWidthPercent": 120,
        "negativeBarColor": { "solid": { "color": "#FF0F12" } },
        "positiveBarColor": { "solid": { "color": "#00FF2E" } }
      }],
      "dataLabels": [{
        "dataLabelDisplayUnits": "0",
        "dataLabelFontColor": { "solid": { "color": "#0100AA" } },
        "dataLabelFontFamily": "Verdana",
        "dataLabelFontSize": 15
      }],
      "levelHeader": [{
        "levelHeaderBackgroundColor": { "solid": { "color": "#000000" } },
        "levelSubtitleFontColor": { "solid": { "color": "#FFFFFF" } },
        "levelSubtitleFontFamily": "Arial",
        "levelSubtitleFontSize": 18,
        "levelTitleFontColor": { "solid": { "color": "#ABCDEF" } },
        "levelTitleFontFamily": "ArialBlack",
        "levelTitleFontSize": 20
      }]
    }
  },
  "donutChart": {
    "*": {
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Segoe UI",
        "fontSize": 12
      }],
      "labels": [{
        "show": true,
        "labelStyle": "Data",
        "color": { "solid": { "color": "#01B8AA" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 10,
        "fontFamily": "Verdana",
        "position": "inside"
      }],
      "slices": [{
        "innerRadiusRatio": 90
      }]
    }
  },
  "filledMap": {
    "*": {
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "defaultColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Segoe UI Light",
        "fontSize": 10
      }],
      "dataPoint": [{
        "defaultCategoryColor": { "solid": { "color": "#01B1AA" } },
        "showAllDataPoints": true

      }],
      "mapControls": [{
        "autoZoom": true,
        "zoomLevel": 4,
        "centerLatitude": 43,
        "centerLongitude": -83
      }],
      "mapStyles": [{
        "mapTheme": "grayscale"
      }]
    }
  },
  "funnel": {
    "*": {
      "categoryAxis": [{
        "show": true,
        "color": { "solid": { "color": "#000000" } },
        "fontSize": 10,
        "fontFamily": "Verdana"
      }],
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#010000" } },
        "showAllDataPoints": true
      }],
      "labels": [{
        "show": true,
        "color": { "solid": { "color": "#01B8AA" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "labelPosition": "OutsideEnd",
        "fontSize": 10,
        "fontFamily": "Verdana"
      }],
      "percentBarLabel": [{
        "show": true,
        "color": { "solid": { "color": "#01B8AA" } },
        "fontSize": 10,
        "fontFamily": "Verdana"
      }]
    }
  },
  "gauge": {
    "*": {
      "axis": [{
        "max": 100,
        "target": 101
      }],
      "dataPoint": [{
        "fill": { "solid": { "color": "#01B8AA" } },
        "target": { "solid": { "color": "#FFB8DD" } }
      }],
      "labels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "fontSize": 11,
        "fontFamily": "Courier New"
      }],
      "target": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "fontSize": 11,
        "fontFamily": "Courier New"
      }],
      "calloutValue": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 1
      }]
    }
  },
  "*": {
    "*": {
      "title": [{
        "show": true,
        "fontColor": { "solid": { "color": "#cc6600" } },
        "background": { "solid": { "color": "#333333" } },
        "alignment": "center",
        "fontSize": 12,
        "fontFamily": "Verdana"
      }],
      "background": [{
        "show": true,
        "color": { "solid": { "color": "#002a5b" } },
        "transparency": 25
      }],
      "lockAspect": [{
        "show": true
      }],
      "border": [{
        "show": true,
        "color": { "solid": { "color": "#886b01" } },
        "radius": 10
      }],
      "visualTooltip": [{
        "type": "Default"
      }],
      "stylePreset": [{
        "name": "None"
      }],
      "visualHeader": [{
        "foreground": { "solid": { "color": "#cc6600" } },
        "border": { "solid": { "color": "#333333" } },
        "showTooltipButton": true
      }],
      "visualHeaderTooltip": [{
        "text": "Header tooltip text",
        "titleFontColor": { "solid": { "color": "#cc6600" } },
        "transparency": 0,
        "background": { "solid": { "color": "#002a5b" } }
      }],
      "dropShadow": [{
        "show": true,
        "angle": 100,
        "color": { "solid": { "color": "#002a5b" } },
        "position": "Outer",
        "preset": "Custom",
        "shadowBlur": 20,
        "shadowDistance": 10,
        "shadowSpread": 7,
        "transparency": 25
      }]
    }
  },
  "page": {
    "*": {
      "background": [{
        "color": { "solid": { "color": "#465d85" } },
        "image": {
          "name": "background",
          "scaling": "Fit",
          "url": "<Base64 Encode>"
        },
        "transparency": 50
      }],
      "outspace": [{
        "color": { "solid": { "color": "#886b01" } },
        "image": {
          "name": "outspace",
          "scaling": "Fit",
          "url": "<Base64 Encode>"
        },
        "transparency": 50
      }],
      "outspacePane": [{
        "backgroundColor": { "solid": { "color": "#ededed" } },
        "foregroundColor": { "solid": { "color": "#3e3e3e" } },
        "borderColor": { "solid": { "color": "#3e3e3e" } },
        "transparency": 0,
        "titleSize": 18,
        "headerSize": 8,
        "fontFamily": "Segoe UI",
        "border": true
      }],
      "filterCard": [
        {
          "$id": "Applied",
          "backgroundColor": { "solid": { "color": "#0c62fb" } },
          "foregroundColor": { "solid": { "color": "#ffffff" } },
          "borderColor": { "solid": { "color": "#c2d8fe" } },
          "inputBoxColor": { "solid": { "color": "#ffffff" } },
          "transparency": 0,
          "textSize": 11,
          "fontFamily": "Segoe UI",
          "border": true
        },
        {
          "$id": "Available",
          "backgroundColor": { "solid": { "color": "#c2d8fe" } },
          "foregroundColor": { "solid": { "color": "#3e3e3e" } },
          "borderColor": { "solid": { "color": "#c2d8fe" } },
          "inputBoxColor": { "solid": { "color": "#c2d8fe" } },
          "transparency": 0,
          "textSize": 10,
          "fontFamily": "Segoe UI",
          "border": true
        }
      ]
    }
  },
  "hundredPercentStackedBarChart": {
    "*": {
      "general": [{
        "responsive": true
      }],
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Courier New",
        "fontSize": 10
      }],
      "categoryAxis": [{
        "show": true,
        "position": "Right",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "innerPadding": 22,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": { "solid": { "color": "#01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      }],
      "valueAxis": [{
        "show": true,
        "position": "Right",
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": { "solid": { "color": "01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": { "solid": { "color": "#01B8AA" } },
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      }],
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#448822" } }
      }],
      "labels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "labelOrientation": "vertical",
        "labelPosition": "OutsideEnd",
        "fontSize": 11,
        "fontFamily": "Courier New",
        "enableBackground": true,
        "backgroundColor": { "solid": { "color": "#0928DD" } },
        "backgroundTransparency": 30
      }],
      "plotArea": [{
        "transparency": 20
      }]
    }
  },
  "hundredPercentStackedColumnChart": {
    "*": {
      "general": [{
        "responsive": true
      }],
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Courier New",
        "fontSize": 10
      }],
      "categoryAxis": [{
        "show": true,
        "position": "Right",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "innerPadding": 22,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": { "solid": { "color": "#01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      }],
      "valueAxis": [{
        "show": true,
        "position": "Right",
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": { "solid": { "color": "01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": { "solid": { "color": "#01B8AA" } },
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      }],
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#448822" } }
      }],
      "labels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "labelOrientation": "vertical",
        "labelPosition": "OutsideEnd",
        "fontSize": 11,
        "fontFamily": "Courier New",
        "enableBackground": true,
        "backgroundColor": { "solid": { "color": "#0928DD" } },
        "backgroundTransparency": 30
      }],
      "plotArea": [{
        "transparency": 20
      }]
    }
  },
  "image": {
    "*": {
      "imageScaling": [{
        "imageScalingType": "Normal"
      }]
    }
  },
  "kpi": {
    "*": {
      "indicator": [{
        "indicatorDisplayUnits": "Auto",
        "indicatorPrecision": 1,
        "showIcon": true,
        "iconSize": 15,
        "horizontalAlignment": "left",
        "verticalAlignment": "top"
      }],
      "trendline": [{
        "show": true
      }],
      "goals": [{
        "showGoal": true,
        "showDistance": true
      }],
      "status": [{
        "direction": "Negative",
        "goodColor": { "solid": { "color": "#01B8AA" } },
        "neutralColor": { "solid": { "color": "#FFB8DD" } },
        "badColor": { "solid": { "color": "#018866" } }
      }]
    }
  },
  "lineChart": {
    "*": {
      "general": [{
        "responsive": true
      }],
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Courier New",
        "fontSize": 10,
        "legendMarkerRendering": "markerOnly",
        "matchLineColor": false
      }],
      "categoryAxis": [{
        "show": true,
        "axisType": "categorical",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": { "solid": { "color": "#01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      }],
      "valueAxis": [{
        "show": true,
        "position": "Right",
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": { "solid": { "color": "01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": { "solid": { "color": "#01B8AA" } },
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      }],
      "y2Axis": [{
        "secStart": 0,
        "secEnd": 2000,
        "secFontSize": 16,
        "secLabelColor": { "solid": { "color": "#0928DD" } },
        "secShowAxisTitle": true,
        "secTitleText": "Secondary Value Axis",
        "secTitleColor": { "solid": { "color": "#448822" } }
      }],
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#448822" } }
      }],
      "labels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "fontSize": 11,
        "fontFamily": "Courier New",
        "enableBackground": true,
        "backgroundColor": { "solid": { "color": "#0928DD" } },
        "backgroundTransparency": 30
      }],
      "lineStyles": [{
        "strokeWidth": 4,
        "strokeLineJoin": "bevel",
        "lineStyle": "dashed",
        "showMarker": true,
        "markerShape": "triangle",
        "markerSize": 10,
        "markerColor": { "solid": { "color": "#448822" } }
      }],
      "plotArea": [{
        "transparency": 20
      }]
    }
  },
  "lineClusteredColumnComboChart": {
    "*": {
      "general": [{
        "responsive": true
      }],
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Courier New",
        "fontSize": 10
      }],
      "categoryAxis": [{
        "show": true,
        "position": "Right",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "innerPadding": 22,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": { "solid": { "color": "#01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      }],
      "valueAxis": [{
        "show": true,
        "position": "Right",
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": { "solid": { "color": "01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": { "solid": { "color": "#01B8AA" } },
        "gridlineThickness": 2,
        "gridlineStyle": "dashed",
        "secShow": true,
        "alignZeros": true,
        "secAxisLabel": "asdfsadf",
        "secPosition": "Left",
        "secAxisScale": "Log",
        "secStart": 0,
        "secEnd": 10,
        "secLabelColor": { "solid": { "color": "#000000" } },
        "secFontSize": 12,
        "secFontFamily": "Verdana",
        "secLabelDisplayUnits": "0",
        "secLabelPrecision": 2,
        "secShowAxisTitle": true,
        "secAxisStyle": "showTitleOnly",
        "secTitleColor": { "solid": { "color": "#01B8AA" } },
        "secTitleText": "aaaa",
        "secTitleFontSize": 10,
        "secTitleFontFamily": "Courier New"
      }],
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#448822" } }
      }],
      "labels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "labelOrientation": "vertical",
        "labelPosition": "OutsideEnd",
        "fontSize": 11,
        "fontFamily": "Courier New",
        "enableBackground": true,
        "backgroundColor": { "solid": { "color": "#0928DD" } },
        "backgroundTransparency": 30
      }],
      "lineStyles": [{
        "shadeArea": true,
        "strokeWidth": 4,
        "strokeLineJoin": "bevel",
        "showMarker": true,
        "markerShape": "triangle",
        "markerSize": 3,
        "markerColor": { "solid": { "color": "#448822" } }
      }],
      "plotArea": [{
        "transparency": 20
      }]
    }
  },
  "lineStackedColumnComboChart": {
    "*": {
      "general": [{
        "responsive": true
      }],
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Courier New",
        "fontSize": 10
      }],
      "categoryAxis": [{
        "show": true,
        "position": "Right",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "innerPadding": 22,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": { "solid": { "color": "#01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      }],
      "valueAxis": [{
        "show": true,
        "position": "Right",
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": { "solid": { "color": "01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": { "solid": { "color": "#01B8AA" } },
        "gridlineThickness": 2,
        "gridlineStyle": "dashed",
        "secShow": true,
        "alignZeros": true,
        "secAxisLabel": "asdfsadf",
        "secPosition": "Left",
        "secAxisScale": "Log",
        "secStart": 0,
        "secEnd": 10,
        "secLabelColor": { "solid": { "color": "#000000" } },
        "secFontSize": 12,
        "secFontFamily": "Verdana",
        "secLabelDisplayUnits": "0",
        "secLabelPrecision": 2,
        "secShowAxisTitle": true,
        "secAxisStyle": "showTitleOnly",
        "secTitleColor": { "solid": { "color": "#01B8AA" } },
        "secTitleText": "aaaa",
        "secTitleFontSize": 10,
        "secTitleFontFamily": "Courier New"
      }],
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#448822" } }
      }],
      "labels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "labelOrientation": "vertical",
        "labelPosition": "OutsideEnd",
        "fontSize": 11,
        "fontFamily": "Courier New",
        "enableBackground": true,
        "backgroundColor": { "solid": { "color": "#0928DD" } },
        "backgroundTransparency": 30
      }],
      "lineStyles": [{
        "shadeArea": true,
        "strokeWidth": 4,
        "strokeLineJoin": "bevel",
        "showMarker": true,
        "markerShape": "triangle",
        "markerSize": 3,
        "markerColor": { "solid": { "color": "#448822" } }
      }],
      "plotArea": [{
        "transparency": 20
      }]
    }
  },
  "map": {
    "*": {
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "legendColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Segoe UI",
        "fontSize": 12
      }],
      "dataPoint": [{
        "defaultCategoryColor": { "solid": { "color": "#01B1AA" } },
        "showAllDataPoints": true

      }],
      "categoryLabels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "fontSize": 10,
        "fontFamily": "Segoe UI",
        "enableBackground": true,
        "backgroundColor": { "solid": { "color": "#000000" } },
        "backgroundTransparency": 50
      }],
      "bubbles": [{
        "bubbleSize": 0
      }],
      "mapControls": [{
        "autoZoom": true,
        "zoomLevel": 4,
        "centerLatitude": 43,
        "centerLongitude": -83
      }],
      "mapStyles": [{
        "mapTheme": "grayscale"
      }]
    }
  },
  "pivotTable": {
    "*": {
      "stylePreset": [{
        "name": "Condensed"
      }],
      "grid": [{
        "gridVertical": true,
        "gridVerticalColor": { "solid": { "color": "#FFB8DD" } },
        "gridVerticalWeight": 2,
        "gridHorizontal": true,
        "gridHorizontalColor": { "solid": { "color": "#FFB8DD" } },
        "gridHorizontalWeight": 2,
        "rowPadding": 2,
        "outlineColor": { "solid": { "color": "#FFB8DD" } },
        "outlineWeight": 2,
        "textSize": 14,
        "imageHeight": 100
      }],
      "columnHeaders": [{
        "fontColor": { "solid": { "color": "#00B8DD" } },
        "backColor": { "solid": { "color": "#00AA22" } },
        "outline": "Frame",
        "autoSizeColumnWidth": true,
        "fontFamily": "Courier New",
        "fontSize": 12,
        "alignment": "Left",
        "titleAlignment": "Right",
        "urlIcon": true,
        "wordWrap": true
      }],
      "rowHeaders": [{
        "fontColor": { "solid": { "color": "#00B8DD" } },
        "backColor": { "solid": { "color": "#00AA22" } },
        "outline": "Frame",
        "stepped": true,
        "steppedLayoutIndentation": 12,
        "urlIcon": true,
        "wordWrap": true,
        "fontFamily": "Courier New",
        "fontSize": 12,
        "alignment": "Left",
        "showExpandCollapseButtons": true
      }],
      "values": [{
        "fontColorPrimary": { "solid": { "color": "#00B8DD" } },
        "backColorPrimary": { "solid": { "color": "#00AA22" } },
        "fontColorSecondary": { "solid": { "color": "#FFB8DD" } },
        "backColorSecondary": { "solid": { "color": "#FFAA22" } },
        "bandedRowHeaders": true,
        "valuesOnRow": true,
        "outline": "Frame",
        "urlIcon": true,
        "wordWrap": true,
        "fontFamily": "Courier New",
        "fontSize": 12
      }],
      "subTotals": [{
        "rowSubtotals": true,
        "columnSubtotals": true,
        "fontColor": { "solid": { "color": "#332222" } },
        "fontFamily": "Verdana",
        "backColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "applyToHeaders": true,
        "rowSubtotalsPosition": "Bottom",
        "perRowLevel": true,
        "perColumnLevel": true
      }],
      "total": [{
        "fontColor": { "solid": { "color": "#00B8DD" } },
        "fontFamily": "Courier New",
        "backColor": { "solid": { "color": "#00AA22" } },
        "applyToHeaders": true,
        "fontSize": 14
      }]
    }
  },
  "multiRowCard": {
    "*": {
      "dataLabels": [{
        "color": { "solid": { "color": "#01B8AA" } },
        "fontSize": 10,
        "fontFamily": "Verdana"
      }],
      "categoryLabels": [{
        "show": true,
        "color": { "solid": { "color": "#000000" } },
        "fontSize": 10,
        "fontFamily": "Verdana"
      }],
      "cardTitle": [{
        "color": { "solid": { "color": "#01B8AA" } },
        "fontSize": 10,
        "fontFamily": "Verdana"
      }],
      "card": [{
        "outline": "TopOnly",
        "outlineColor": { "solid": { "color": "#000000" } },
        "outlineWeight": 2,
        "barShow": true,
        "barColor": { "solid": { "color": "#01B8AA" } },
        "barWeight": 2,
        "cardPadding": 20,
        "cardBackground": { "solid": { "color": "#EEEEEE" } }
      }]
    }
  },
  "pieChart": {
    "*": {
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "legendColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Segoe UI",
        "fontSize": 12
      }],
      "labels": [{
        "show": true,
        "labelStyle": "Data",
        "color": { "solid": { "color": "#01B8AA" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 10,
        "fontFamily": "Verdana",
        "position": "inside"
      }]
    }
  },
  "ribbonChart": {
    "*": {
      "general": [{
        "responsive": true
      }],
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Courier New",
        "fontSize": 10
      }],
      "categoryAxis": [{
        "show": true,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Segoe UI",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "innerPadding": 22,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": { "solid": { "color": "#01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      }],
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#448822" } }
      }],
      "labels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "labelOrientation": "vertical",
        "labelPosition": "InsideEnd",
        "fontSize": 11,
        "fontFamily": "Courier New",
        "enableBackground": true,
        "backgroundColor": { "solid": { "color": "#0928DD" } },
        "backgroundTransparency": 30
      }],
      "plotArea": [{
        "transparency": 20
      }],
      "ribbonChart": [{
        "colorBands": true,
        "bandsTransparency": 20,
        "showBorder": true
      }]
    }
  },
  "scatterChart": {
    "*": {
      "general": [{
        "responsive": true,
        "dataVolume": 10000
      }],
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Courier New",
        "fontSize": 10
      }],
      "categoryAxis": [{
        "show": true,
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": { "solid": { "color": "01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": { "solid": { "color": "#01B8AA" } },
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      }],
      "valueAxis": [{
        "show": true,
        "position": "Right",
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": { "solid": { "color": "01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": { "solid": { "color": "#01B8AA" } },
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      }],
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#448822" } }
      }],
      "shapes": [{
        "markerSize": 3,
        "markerStyle": "triangle",
        "customizeSeries": true
      }],
      "plotArea": [{
        "transparency": 20
      }],
      "categoryLabels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "fontSize": 11,
        "fontFamily": "Courier New",
        "enableBackground": true,
        "backgroundColor": { "solid": { "color": "#0928DD" } },
        "backgroundTransparency": 30
      }],
      "fillPoint": [{
        "show": false
      }],
      "colorByCategory": [{
        "show": false
      }]
    }
  },
  "basicShape": {
    "*": {
      "line": [{
        "lineColor": { "solid": { "color": "#01B8AA" } },
        "transparency": 0,
        "weight": 3,
        "roundEdge": 0
      }],
      "fill": [{
        "show": true,
        "fillColor": { "solid": { "color": "#DDDDDD" } },
        "transparency": 0
      }],
      "rotation": [{
        "angle": 0
      }],
      "visualHeader": [{
        "show": false
      }]
    }
  },
  "shapeMap": {
    "*": {
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#01B8AA" } },
        "showAllDataPoints": true
      }],
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "legendColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Segoe UI",
        "fontSize": 12
      }],
      "shape": [{
        "map": "",
        "projectionEnum": "mercator"
      }],
      "defaultColors": [{
        "defaultShow": true,
        "defaultColor": { "solid": { "color": "#DDDDDD" } },
        "borderColor": { "solid": { "color": "#222222" } },
        "borderThickness": 1
      }],
      "zoom": [{
        "autoZoom": true,
        "selectionZoom": true,
        "manualZoom": true
      }]
    }
  },
  "slicer": {
    "*": {
      "general": [{
        "outlineColor": { "solid": { "color": "#444444" } },
        "outlineWeight": 1,
        "orientation": "vertical",
        "responsive": true
      }],
      "data": [{
        "mode": "Basic",
        "relativeRange": "",
        "relativePeriod": ""
      }],
      "selection": [{
        "selectAllCheckboxEnabled": false,
        "singleSelect": true
      }],
      "header": [{
        "show": true,
        "fontColor": { "solid": { "color": "#000000" } },
        "background": { "solid": { "color": "" } },
        "outline": "None",
        "textSize": 10,
        "fontFamily": "Segoe UI"
      }],
      "items": [{
        "fontColor": { "solid": { "color": "#000000" } },
        "background": { "solid": { "color": "" } },
        "outline": "None",
        "textSize": 11,
        "fontFamily": "Segoe UI"
      }],
      "slider": [{
        "color": { "solid": { "color": "#FF373A" } }
      }]
    }
  },
  "stackedAreaChart": {
    "*": {
      "general": [{
        "responsive": true
      }],
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Courier New",
        "fontSize": 10,
        "legendMarkerRendering": "markerOnly",
        "matchLineColor": false
      }],
      "categoryAxis": [{
        "show": true,
        "axisType": "categorical",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": { "solid": { "color": "#01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      }],
      "valueAxis": [{
        "show": true,
        "position": "Right",
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": { "solid": { "color": "01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": { "solid": { "color": "#01B8AA" } },
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      }],
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#448822" } }
      }],
      "labels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "fontSize": 11,
        "fontFamily": "Courier New",
        "enableBackground": true,
        "backgroundColor": { "solid": { "color": "#0928DD" } },
        "backgroundTransparency": 30
      }],
      "lineStyles": [{
        "strokeWidth": 4,
        "strokeLineJoin": "bevel",
        "lineStyle": "dashed",
        "showMarker": true,
        "markerShape": "triangle",
        "markerSize": 10,
        "markerColor": { "solid": { "color": "#448822" } },
        "showSeries": true
      }],
      "plotArea": [{
        "transparency": 20
      }]
    }
  },
  "barChart": {
    "*": {
      "general": [{
        "responsive": true
      }],
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Courier New",
        "fontSize": 10
      }],
      "categoryAxis": [{
        "show": true,
        "position": "Right",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "innerPadding": 22,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": { "solid": { "color": "#01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      }],
      "valueAxis": [{
        "show": true,
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": { "solid": { "color": "01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": { "solid": { "color": "#01B8AA" } },
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      }],
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#448822" } }
      }],
      "labels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "fontSize": 11,
        "fontFamily": "Courier New",
        "enableBackground": true,
        "backgroundColor": { "solid": { "color": "#0928DD" } },
        "backgroundTransparency": 30
      }],
      "plotArea": [{
        "transparency": 20
      }]
    }
  },
  "columnChart": {
    "*": {
      "general": [{
        "responsive": true
      }],
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Courier New",
        "fontSize": 10
      }],
      "categoryAxis": [{
        "show": true,
        "position": "Right",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "innerPadding": 22,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": { "solid": { "color": "#01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      }],
      "valueAxis": [{
        "show": true,
        "position": "Right",
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": { "solid": { "color": "01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": { "solid": { "color": "#01B8AA" } },
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      }],
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#448822" } }
      }],
      "labels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "labelOrientation": "vertical",
        "labelPosition": "OutsideEnd",
        "fontSize": 11,
        "fontFamily": "Courier New",
        "enableBackground": true,
        "backgroundColor": { "solid": { "color": "#0928DD" } },
        "backgroundTransparency": 30
      }],
      "plotArea": [{
        "transparency": 20
      }]
    }
  },
  "tableEx": {
    "*": {
      "grid": [{
        "gridVertical": true,
        "gridVerticalColor": { "solid": { "color": "#FFB8DD" } },
        "gridVerticalWeight": 2,
        "gridHorizontal": true,
        "gridHorizontalColor": { "solid": { "color": "#FFB8DD" } },
        "gridHorizontalWeight": 2,
        "rowPadding": 2,
        "outlineColor": { "solid": { "color": "#FFB8DD" } },
        "outlineWeight": 2,
        "textSize": 14,
        "imageHeight": 100
      }],
      "columnHeaders": [{
        "fontColor": { "solid": { "color": "#00B8DD" } },
        "backColor": { "solid": { "color": "#00AA22" } },
        "outline": "Frame",
        "autoSizeColumnWidth": true,
        "fontFamily": "Courier New",
        "fontSize": 12,
        "alignment": "Left",
        "wordWrap": true
      }],
      "values": [{
        "fontColorPrimary": { "solid": { "color": "#00B8DD" } },
        "backColorPrimary": { "solid": { "color": "#00AA22" } },
        "fontColorSecondary": { "solid": { "color": "#FFB8DD" } },
        "backColorSecondary": { "solid": { "color": "#FFAA22" } },
        "outline": "Frame",
        "urlIcon": true,
        "wordWrap": true,
        "fontFamily": "Courier New",
        "fontSize": 12
      }],
      "total": [{
        "totals": true,
        "fontColor": { "solid": { "color": "#00B8DD" } },
        "backColor": { "solid": { "color": "#00AA22" } },
        "outline": "Frame",
        "fontFamily": "Courier New",
        "fontSize": 14
      }],
      "stylePreset": [{
        "name": "BoldHeader"
      }]
    }
  },
  "textbox": {
    "*": {
      "*": [{
        "fontSize": 40,
        "fontFamily": "Calibri",
        "wordWrap": true,
        "color": { "solid": { "color": "#FFFFFF" } }
      }],
      "background": [{
        "show": true,
        "color": { "solid": { "color": "#DDDDDD" } },
        "transparency": 0
      }],
      "visualHeader": [{
        "show": true
      }]
    }
  },
  "treemap": {
    "*": {
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "legendColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Segoe UI",
        "fontSize": 12
      }],
      "labels": [{
        "show": true,
        "labelStyle": "Data",
        "color": { "solid": { "color": "#01B8AA" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 10,
        "fontFamily": "Verdana"
      }],
      "categoryLabels": [{
        "show": true,
        "color": { "solid": { "color": "#01B8AA" } },
        "fontSize": 10,
        "fontFamily": "Verdana"
      }]
    }
  },
  "waterfallChart": {
    "*": {
      "general": [{
        "responsive": true
      }],
      "legend": [{
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontFamily": "Courier New",
        "fontSize": 10
      }],
      "categoryAxis": [{
        "show": true,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "innerPadding": 22,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": { "solid": { "color": "#01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      }],
      "valueAxis": [{
        "show": true,
        "position": "Right",
        "start": 0,
        "end": 10,
        "labelColor": { "solid": { "color": "#01B8AA" } },
        "fontSize": 14,
        "fontFamily": "Courier New",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": { "solid": { "color": "01B8AA" } },
        "titleText": "asdf",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": { "solid": { "color": "#01B8AA" } },
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      }],
      "dataPoint": [{
        "defaultColor": { "solid": { "color": "#448822" } }
      }],
      "labels": [{
        "show": true,
        "color": { "solid": { "color": "#EEEEEE" } },
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "labelOrientation": "vertical",
        "labelPosition": "OutsideEnd",
        "fontSize": 11,
        "fontFamily": "Courier New",
        "enableBackground": true,
        "backgroundColor": { "solid": { "color": "#0928DD" } },
        "backgroundTransparency": 30
      }],
      "plotArea": [{
        "transparency": 20
      }],
      "sentimentColors": [{
        "increaseFill": { "solid": { "color": "#0928DD" } },
        "decreaseFill": { "solid": { "color": "#AA28DD" } },
        "totalFill": { "solid": { "color": "#FF28DD" } },
        "otherFill": { "solid": { "color": "#09EEDD" } }
      }],
      "breakdown": [{
        "maxBreakdowns": 3
      }]
    }
  }
}
